import SideMenuTitle from "./SideMenuTitle.vue";
export default SideMenuTitle;
